import React from 'react';
import PropTypes from 'prop-types';

import DatePicker from 'components/DatePicker';

import './styles.scss';

const PickUp = ({
  controlledDate, handleChange, reference, pickUpDate, onFocusInput, setDateManualyHand,
  prevDisabled, openModal, saveDeliveryHandl, position
}) => (
  // eslint-disable-next-line
  <div className="pick-up">
    <DatePicker
      controlledDate={controlledDate}
      handleChange={handleChange}
      reference={reference}
      pickUpDate={pickUpDate}
      onFocusInput={onFocusInput}
      setDateManualyHand={setDateManualyHand}
      prevDisabled={prevDisabled}
    />
    <p className="pick-up-desription">
      When and where it will be convenient for you to pick up your car?
    </p>

    <div className="pick-up-list">

      <div className="list-item">
        <button className="item-header" onClick={openModal}>
          <div className="header-location">
            <i className="material-icons">&#xE0C8;</i>
            {/* 4.3 KM */}
          </div>
          <p className="header-title">
            27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3
          </p>
          <i className="icon-arrow-right" />
        </button>

        <div className="item-hours">
          <button className="item-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', '2:00 PM')}>
            2:00 PM
          </button>
        </div>
        <div className="item-hours">
          <button className="item-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', '4:00 PM')}>
            4:00 PM
          </button>
        </div>
        <div className="item-hours">
          <button className="item-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', '6:00 PM')}>
            6:00 PM
          </button>
        </div>
      </div>
    </div>

  </div>
);

PickUp.propTypes = {
  controlledDate: PropTypes.instanceOf(Date).isRequired,
  handleChange: PropTypes.func.isRequired,
  reference: PropTypes.func.isRequired,
  pickUpDate: PropTypes.string.isRequired,
  onFocusInput: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  prevDisabled: PropTypes.bool.isRequired,
  setDateManualyHand: PropTypes.func.isRequired,
  saveDeliveryHandl: PropTypes.func.isRequired,
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }).isRequired
};

export default PickUp;




// WEBPACK FOOTER //
// ./src/pages/Delivery/components/PickUp/index.js